import Quill from 'quill';

export default function dividerHandler() {
  const range = this.quill.getSelection(true);
  this.quill.insertText(range.index, '\n', Quill.sources.USER);
  this.quill.insertEmbed(range.index + 1, 'divider', true, Quill.sources.USER);
  this.quill.setSelection(range.index + 2, Quill.sources.SILENT);
}
